import React, { useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Modal } from "reactstrap";
import { InputField } from "../../Component/Common/InputField";
import { modalFileSchema } from "../../helper/errorSchema";
import { checkFormError } from "../../helper";
import { uploadExcelCastProApi } from "../../services/serviceCastPro";

// The "Upload" modal from CastPro.js, moved to its own routed page.
export const UploadCast = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [inputValue, setInputValue] = useState({});
  const [inputError, setInputError] = useState({});
  const [isLoadding, setIsLoadding] = useState(false);

  const goBackToList = () => navigate("/cast-management");

  const uploadMutation = useMutation(uploadExcelCastProApi, {
    onSuccess: (res) => {
      setIsLoadding(false);
      if (res?.success) {
        toast.success(res?.results?.success || "success");
        queryClient.refetchQueries("getCastProfession");
        goBackToList();
      }
    },
  });

  const handleOnChange = async (name, value) => {
    const stateObj = { ...inputValue, [name]: value };
    setInputValue(stateObj);
    const error = await checkFormError(stateObj, modalFileSchema);
    setInputError(error);
  };

  const onSubmitUpload = async () => {
    const validationResult = await checkFormError({ excel_file: inputValue.excel_file }, modalFileSchema);
    if (validationResult === true) {
      setIsLoadding(true);
      const formData = new FormData();
      formData.append("excel_file", inputValue?.excel_file);
      uploadMutation.mutate(formData);
    } else {
      setInputError(validationResult);
    }
  };

  return (
    <Modal isOpen toggle={goBackToList} centered className="avf-dialog" contentClassName="avf-content">
      <div className="avf-header">
        <div className="avf-header-top">
          <div>
            <h2 className="avf-title">Upload Cast &amp; Profession</h2>
            <p className="avf-subtitle">Bulk-add caste and profession records from an Excel file</p>
          </div>
          <button type="button" className="avf-close-btn" onClick={goBackToList} aria-label="Close">
            ×
          </button>
        </div>
      </div>

      <div className="avf-body">
        <div className="avf-section">
          <div className="avf-section-head">
            <span className="avf-section-num">1</span>
            <h3 className="avf-section-title">Excel File</h3>
          </div>
          <div className="avf-grid">
            <div className="avf-field">
              <InputField
                className="modal_input"
                label="File"
                labelClass="modal_label"
                labelSpan="*"
                labelSpanClass="style_for_star"
                placeholder="Select File"
                name="excel_file"
                type="file"
                focus={!!inputError.excel_file}
                error={inputError.excel_file}
                onChange={({ target: { name, files } }) => handleOnChange(name, files[0])}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="avf-footer">
        <div className={`avf-footer-note ${inputError?.excel_file ? "has-errors" : ""}`}>
          {inputError?.excel_file || "1 required field"}
        </div>
        <div className="avf-footer-actions">
          <button type="button" className="avf-btn avf-btn-secondary" onClick={goBackToList}>
            Cancel
          </button>
          {isLoadding ? (
            <button type="button" className="avf-btn avf-btn-primary" disabled>
              Processing...
            </button>
          ) : (
            <button
              type="button"
              className="avf-btn avf-btn-primary"
              disabled={!inputValue?.excel_file}
              onClick={onSubmitUpload}
            >
              Upload
            </button>
          )}
        </div>
      </div>
    </Modal>
  );
};
